<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Sub-categories</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Sub-categories</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <a href="javascript:void(0)" class="btn btn-info" @click="showFilter = !showFilter"><i
              class="fa fa-filter"></i>Filter</a>
            <div class="card-tools">
              <router-link :to="{ name: 'SubCategoryCreate'}" class="btn btn-success"><i class="fas fa-plus"></i> New
              </router-link>
            </div>
          </div>
          <form @submit.prevent="getItems" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="name">Name</label>
                    <div class="col-md-9">
                      <input type="text" id="name" class="form-control" v-model="filter.name" placeholder="Name">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px">Search</button>
                      <button type="reset" class="btn btn-warning" @click="resetFilter()">Reset</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
              <tr>
                <th style="width: 10px">ID</th>
                <th>Sub-category name</th>
                <th>Category name</th>
                <th>Description</th>
                <th class="text-right">Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in items.data">
                <td>{{ item.id }}</td>
                <td>{{ item.sub_category_name }}</td>
                <td>{{ item.category.name }}</td>
                <td>{{ item.description }}</td>
                <td class="text-right">
                  <router-link :to="{ name: 'SubCategoryShow', params: { id: item.id }}"
                               class="btn btn-info btn-sm m-2px">
                    <i class="fas fa-eye"></i>
                  </router-link>
                  <router-link :to="{ name: 'SubCategoryEdit', params: { id: item.id }}"
                               class="btn btn-info btn-sm m-2px">
                    <i class="fas fa-pencil-alt"></i>
                  </router-link>
                  <button class="btn btn-danger btn-sm m-2px" @click="destroy(item.id, index)">
                    <i class="fas fa-trash"></i></button>
                </td>
              </tr>
              </tbody>
            </table>

            <div class="p-4" v-if="_.isEmpty(items.data)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination
              :pagination="items"
              v-if="items.total > items.per_page"
              @paginate="getItems()"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import { CategoryAPI } from "@/services/api";

export default {
  name: 'SubCategoryList',
  metaInfo: {
    title: 'Sub-category List | Dotlines'
  },
  components: {
    VuePagination
  },
  data: () => ({
    items: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1
    },
    showFilter: false,
    filter: {},
    is_loading: false
  }),
  methods: {
    getItems() {
      this.is_loading = true;
      CategoryAPI.subCategoryIndex(this.items.current_page, this.filter)
        .then(items => {
          this.items = items;
        }).finally(() => {
          this.is_loading = false;
      });
    },
    resetFilter() {
      this.items.current_page = 1;
      this.filter = {};
      this.showFilter = false;
      this.getItems();
    },
    destroy(id, index) {
      this.$swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        confirmButtonText: 'Yes, delete it!',
        icon: 'warning',
        showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33',
      }).then((result) => {
        if (result.isConfirmed) {
          this.is_loading = true;
          CategoryAPI.subCategoryDestroy(id)
            .then(response => {
              this.items.data.splice(index, 1);
              this.items.total--;
              this.$toaster.success(response.message);
            })
            .catch(error => {
              console.log("Could not delete this:: ", error);
              this.$swal.fire('Failed!', 'Failed to delete.', 'error');
            }).finally(() => {
            this.is_loading = false;
          });
        }
      });
    }
  },
  mounted() {
    this.getItems();
  },
}
</script>
